// extracted by mini-css-extract-plugin
export default {"file":"Files_file__p5HJO","error":"Files_error__+XKGD","files":"Files_files__fzuES"};